import { Tooltip } from "@mui/material";
import React from "react";
import { toast } from "react-hot-toast";

const ViewChatbotOffering = ({ chatbotOffering, categories, countries, tiers }) => {
  if (!chatbotOffering) return null;

  const {
    preference,
    category_ids,
    country_ids,
    tier,
    offer,
    brand,
    creative_media,
    detail_url,
    backup_offer_detail,
    terms_and_conditions,
    priority,
    status,
    created_at,
    updated_at,
    brand_id,
  } = chatbotOffering;


  const getCategoryNames = () =>
    categories
      .filter((cat) => category_ids.includes(cat.id))
      .map((cat) => cat.category)
      .join(", ");

  const getCountryNames = () =>
    countries
      .filter((c) => country_ids.includes(c.id))
      .map((c) => c.name)
      .join(", ");

  const getTierName = () => {
    if (!Array.isArray(tier)) return "";
    return tier
      .map((id) => tiers.find((t) => t.id === id)?.tier)
      .filter(Boolean) // remove undefined
      .join(", ");
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(creative_media);
    toast(" Image URL copied to clipboard!", { icon: "⚠️" });
  };


  return (
    <div className="p-4 max-w-3xl mx-auto bg-white rounded-lg shadow-md space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <strong>Preference:</strong> {preference}
        </div>
        <div>
          <strong>Categories:</strong> {getCategoryNames()}
        </div>
        <div>
          <strong>Countries:</strong> {getCountryNames()}
        </div>
        <div>
          <strong>Tier:</strong> {getTierName()}
        </div>
        <div>
          <strong>Offer:</strong> {offer}
        </div>
        <div>
          <strong>Brand:</strong> {brand}
        </div>
        <div>
          <strong>Brand ID:</strong> {brand_id}
        </div>
        <div>
          <strong>Priority:</strong> {priority}
        </div>
        <div>
          <strong>Status:</strong> {status === 1 ? "Active" : "Inactive"}
        </div>
        <div className="col-span-2 flex justify-center items-center flex-col">
          <strong>Creative Media URL:</strong>{" "}
          <Tooltip title="Click to copy image URL" arrow>
            <img
              src={creative_media}
              alt="Creative Media"
              className="w-50 rounded-4 mt-3 cursor-pointer hover:opacity-80"
              onClick={handleCopy}
            />
          </Tooltip>
        </div>
        <div className="col-span-2">
          <strong>Detail URL:</strong>{" "}
          <a
            href={detail_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline"
          >
            {detail_url}
          </a>
        </div>
        <div className="col-span-2">
          <strong>Backup Offer Detail:</strong>
          <div
            className="p-2 border rounded bg-gray-50 mt-1"
            dangerouslySetInnerHTML={{ __html: backup_offer_detail }}
          />
        </div>
        <div className="col-span-2">
          <strong>Terms & Conditions:</strong>
          <div
            className="p-2 border rounded bg-gray-50 mt-1"
            dangerouslySetInnerHTML={{ __html: terms_and_conditions }}
          />
        </div>
        <div>
          <strong>Created At:</strong> {new Date(created_at).toLocaleString()}
        </div>
        <div>
          <strong>Updated At:</strong> {new Date(updated_at).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default ViewChatbotOffering;
